<template>
  <v-form v-model="formValid">
    <v-subheader class="font-italic font-weight-light py-1">Generale</v-subheader>
    <v-row no-gutters class="py-1">
      <v-col>
        <v-text-field
          v-model="name"
          :rules="[max255CharRule, presenceRule]"
          dense
          filled
          label="Nome"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters class="py-1">
      <v-col>
        <v-text-field
          v-model="description"
          :rules="[max255CharRule, presenceRule]"
          dense
          filled
          label="Descrizione"
          hide-details="auto"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import Vue from 'vue'
import paymentCreditForm from '@/services/paymentCredits/paymentCredit.form.js'

export default {
  name: "GeneralFormTab",
  components: {},
  data: function() {
    return {
      name: undefined,
      description: undefined,
      loadingPaymentCredit: false,
      formValid: false,
      max255CharRule: (v) => {
        if(v) {
          return v.length <= 255 || 'Al massimo 255 caratteri'
        } else {
          return true
        }
      },
      presenceRule: (v) => {
        return !!v || 'Il campo è obbligatorio'
      },
    };
  },
  props: {
    bus: {
      type: Object,
      default: function() {
        return new Vue()
      }
    }
  },
  mounted: function() {
    this.handleObjectChanges(paymentCreditForm.paymentCredit)

    var self = this
    paymentCreditForm.on('update', function(data) {
      self.handleObjectChanges(data.paymentCredit)
    })
  },
  methods: {
    fields() {
      return ['name', 'description']
    },
    handleObjectChanges(paymentCredit) {
      const fields = this.fields()
      const newValKeys = Object.keys(paymentCredit)

      for(let i = 0; i < fields.length; i++) {
        const field = fields[i]
        if(newValKeys.includes(field) && paymentCredit[field] != this[field]) {
          this[field] = paymentCredit[field]
        }
      }
    },
  },
  watch: {
    formValid(newVal) {
      this.$emit('update:valid', newVal)
      if(this.bus) {
        this.bus.$emit('update:valid', newVal)
      }
      paymentCreditForm.setValid(newVal)
    },
    name(newVal) {
      paymentCreditForm.updateField('name', newVal)
    },
    description(newVal) {
      paymentCreditForm.updateField('description', newVal)
    },
  }
};
</script>